import { buttonStyle, inputStyle } from "../../styles/formStyles";

const PersonalInfo = () => {
  return (
    <div className="flex flex-col p-8 rounded-md shadow-md font-inter">
      <h2 className="text-md text-main-black font-bold mb-6">Personal Info</h2>
      <hr className="border-almost-white mb-10" />
      <form className="flex flex-row gap-2">
        <p className="text-md text-light-gray w-4/5">
          This value represents the value that you currently hold.
        </p>
        <input
          type="number"
          placeholder="Inicial Balance"
          className={inputStyle}
        ></input>
        <button className={`${buttonStyle} w-36`}>SAVE BALANCE</button>
      </form>
    </div>
  );
};

export default PersonalInfo;
